document.addEventListener('DOMContentLoaded', function() {
  const searchContainer = document.querySelector('faq-search-form');
  if (!searchContainer) return;

  const form = searchContainer.querySelector('form');
  if (!form) return;

  form.addEventListener('submit', function(event) {
    event.preventDefault();

    const allGroups = document.querySelectorAll('.faq-group');
    let firstVisibleGroup = null;

    for (const group of allGroups) {
      if (group.offsetParent !== null) {
        firstVisibleGroup = group;
        break;
      }
    }

    if (firstVisibleGroup) {
      const title = firstVisibleGroup.querySelector('.faq-group-title');
      const target = title || firstVisibleGroup;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      const input = form.querySelector('input');
      if (input) input.blur();
    }
  });
});